import * as styledComponents from 'styled-components';
import { from } from "./from/from";
import { Theme } from "./Theme";
import { to } from "./to/to";
var _ref = styledComponents,
    styled = _ref.default,
    css = _ref.css,
    createGlobalStyle = _ref.createGlobalStyle,
    keyframes = _ref.keyframes,
    ThemeProvider = _ref.ThemeProvider;
export { css, createGlobalStyle, keyframes, Theme, ThemeProvider, from, to };
export default styled;